import { createContext, useContext } from 'react';
export const ComboBoxContext = createContext({
    onSelect: () => void 0,
    maybeClose: () => void 0,
    lastUsedKeyRef: { current: null },
});
export const useComboBoxContext = () => {
    return useContext(ComboBoxContext);
};
//# sourceMappingURL=ComboBoxContext.js.map